'use client';

import { LogoCarouselItem } from "@/app/parts/home-page/LogoCarousel";
import {useEffect, useMemo, useRef, useState} from "react";
import VadImage from "vadimages-nextjs-image-optimizer";

interface SnaptixImageCarouselSliderProps {
    images: LogoCarouselItem[];
    isMobile?: boolean;
    startOffset?: number;
}

export const SnaptixImageCarouselSlider = ({ images, isMobile = false, startOffset = 180 }: SnaptixImageCarouselSliderProps) => {
    const [currentIndex, setCurrentIndex] = useState<number>(1);
    const [isAnimating, setAnimating] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    const imagesToUse = useMemo(() => [
        images[images.length - 1],
        ...images,
        images[0],
        images[1],
    ], [images]);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimating(currentIndex !== images.length + 1);
            if (currentIndex === images.length + 1) {
                setCurrentIndex(1);
            } else {
                setCurrentIndex(currentIndex + 1);
            }
        }, 2000);

        return () => clearInterval(interval);
    }, [currentIndex, images.length, imagesToUse.length]);

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.clientWidth)
        }
    }, []);

    const sliderWidth = imagesToUse
        .map((image) => image.width)
        .reduce((acc, cur) => acc + cur, 0);

    const cumulativeOffset = imagesToUse
        .slice(0, currentIndex)
        .reduce((acc, img) => acc + img.width + (isMobile ? 1.8 : 5.4), 0);

    console.log({ cumulativeOffset, sliderWidth, currentIndex });

    return (
        <div className={`w-full overflow-hidden absolute left-0 ${!isMobile ? 'top-1/2 -translate-y-1/2' : 'bottom-4'}`} ref={containerRef}>
            <div
                className="flex gap-4 md:gap-12 w-full"
                style={{
                    transition: isAnimating ? 'transform 0.5s ease' : 'none',
                    width: `${sliderWidth}px`,
                    transform: `translateX(${containerWidth / 2 - (cumulativeOffset + images[0].width / 2) + 7}px)`,
                }}
            >
                {
                    imagesToUse.map((image, i) => (
                        <VadImage
                            src={image.src}
                            alt={image.alt}
                            width={image.width}
                            height={image.height}
                            key={`slider-image-${i}`}
                        />
                    ))
                }
            </div>
        </div>
    );
};